import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-125" data-mp="1iw32ha07833a">
      <div className="mx-auto max-w-6xl px-4" data-id="element-126" data-mp="1dxjkfkoq7bg7">
        <div className="text-center" data-id="element-127" data-mp="1dunlpu520iqp">
          <span className="inline-flex items-center gap-2 rounded-full border border-earth-200 bg-earth-100 px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-earth-700" data-id="element-128" data-mp="2bkiedno1a5ae">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-129" data-mp="21ljil5oda44t" /> Complete classroom coverage
          </span>
          <h2 id="modules-title" className="mt-4 text-3xl font-extrabold text-forest-900 sm:text-4xl" data-id="element-130" data-mp="1wnrdtb2minj7">
            The {totalVolumes} comprehensive volumes
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-131" data-mp="l7b7q8cylj90">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.3,
            delay: index % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-xl border border-earth-200 bg-white shadow-sm" data-id="element-132" data-mp="1it5q4j0jyhkz" data-mpi={index}>
                <div className="flex items-center gap-4 bg-forest-800 px-6 py-5" data-id="element-133" data-mp="14vpi532lyfr4">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-gold-500 text-forest-900" data-id="element-134" data-mp="q736pcg3q856">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-135" data-mp="v6fsdtv8l966" />
                  </span>
                  <div data-id="element-136" data-mp="h6xxqxv9f1ow">
                    <p className="text-xs font-bold uppercase tracking-[.14em] text-gold-400" data-id="element-137" data-mp="h6eos6nl7nn0">Volume {module.number}</p>
                    <h3 className="mt-1 text-lg font-bold leading-tight text-cream" data-id="element-138" data-mp="l9kxrm233sx6">{module.title}</h3>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-139" data-mp="2j35jdg91073x">
                  <p className="font-semibold text-forest-900" data-id="element-140" data-mp="2j1m1xmbmvq0k">{module.subtitle}</p>

                  <p className="mt-5 text-xs font-bold uppercase tracking-[.12em] text-earth-500" data-id="element-141" data-mp="2e29ep0guogxg">
                    What does it solve in the classroom?
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-142" data-mp="36shoa3xblt0f">{module.context}</p>

                  <ul className="mt-5 grid flex-1 content-start gap-2" data-id="element-143" data-mp="31v7xoky73bb0">
                    {module.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-ink" data-id="element-144" data-mp="2wwwrqlb0tky2">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest-600" aria-hidden="true" data-id="element-145" data-mp="2ssyobyenxnz7" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-6 rounded-lg border-l-4 border-gold-500 bg-forest-50 p-4 text-sm leading-relaxed text-forest-900" data-id="element-146" data-mp="1hg5zowh65fnd">
                    <b className="font-extrabold" data-id="element-147" data-mp="x4e6jtu47mi">Result: </b>
                    {module.result}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl bg-earth-700 px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-148" data-mp="anp7brqqojy1">
          <p className="text-xs font-bold uppercase tracking-[.16em] text-earth-100" data-id="element-149" data-mp="foms8c34vs38">Main collection</p>
          <p className="font-display text-2xl font-extrabold text-cream sm:text-3xl" data-id="element-150" data-mp="kng3ryyv190r">
            {totalVolumes} premium volumes <span className="mx-2 text-gold-400" data-id="element-151" data-mp="tm1jlmcy69xu">·</span> Updated for 2026
          </p>
        </div>
      </div>
    </section>;
}